/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pool_Long_RunInputs */

const bn_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লং রান`)
};

const de_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langfristig`)
};

const el_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long Run`)
};

const en_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long Run`)
};

const es_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largo plazo`)
};

const fr_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partie longue`)
};

const hi_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे जाकर`)
};

const hu_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosszú futás`)
};

const id_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangka Panjang`)
};

const it_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lungo periodo`)
};

const ja_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロングラン`)
};

const ko_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장기적으로`)
};

const nl_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lange termijn`)
};

const pl_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Długi bieg`)
};

const pt_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longo prazo`)
};

const ru_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длинный забег`)
};

const sv_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Långt lopp`)
};

const tr_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzun Vade`)
};

const uk_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Довгий біг`)
};

const vi_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạy dài`)
};

const zh_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长跑`)
};

const zh_hant_pool_long_run = /** @type {(inputs: Pool_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長跑`)
};

/**
* | output |
* | --- |
* | "Long Run" |
*
* @param {Pool_Long_RunInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const pool_long_run = /** @type {((inputs?: Pool_Long_RunInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pool_Long_RunInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_pool_long_run(inputs)
	if (locale === "de") return de_pool_long_run(inputs)
	if (locale === "el") return el_pool_long_run(inputs)
	if (locale === "en") return en_pool_long_run(inputs)
	if (locale === "es") return es_pool_long_run(inputs)
	if (locale === "fr") return fr_pool_long_run(inputs)
	if (locale === "hi") return hi_pool_long_run(inputs)
	if (locale === "hu") return hu_pool_long_run(inputs)
	if (locale === "id") return id_pool_long_run(inputs)
	if (locale === "it") return it_pool_long_run(inputs)
	if (locale === "ja") return ja_pool_long_run(inputs)
	if (locale === "ko") return ko_pool_long_run(inputs)
	if (locale === "nl") return nl_pool_long_run(inputs)
	if (locale === "pl") return pl_pool_long_run(inputs)
	if (locale === "pt") return pt_pool_long_run(inputs)
	if (locale === "ru") return ru_pool_long_run(inputs)
	if (locale === "sv") return sv_pool_long_run(inputs)
	if (locale === "tr") return tr_pool_long_run(inputs)
	if (locale === "uk") return uk_pool_long_run(inputs)
	if (locale === "vi") return vi_pool_long_run(inputs)
	if (locale === "zh") return zh_pool_long_run(inputs)
	return zh_hant_pool_long_run(inputs)
});